import * as React from "react";
import { Col } from "reactstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

// Utils
import { returnChartData } from "./Utils";

class AnnualChart extends React.Component<{ requests: Array<any> }> {
  render() {
    const { requests } = this.props;

    const chartData = returnChartData(requests);

    return (
      <Col xs={12} md={6} lg={6}>
        <ResponsiveContainer>
          <BarChart
            width={600}
            height={300}
            data={chartData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="Received" fill="#ffa366" />
            <Bar dataKey="Accepted" fill="#33cccc" />
          </BarChart>
        </ResponsiveContainer>
      </Col>
    );
  }
}

export default AnnualChart;



// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerRequestsCharts/AnnualChart.tsx